import { HttpResponse } from "@angular/common/http";
import { map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./jquery-runner";
export class HttpInterceptorService {
    constructor(jqueryRunner) {
        this.jqueryRunner = jqueryRunner;
    }
    intercept(req, next) {
        const token = (sessionStorage.hasOwnProperty('auth') && sessionStorage.getItem('auth')) ?
            sessionStorage.getItem('auth') : null;
        let newHeaders = req.headers;
        if (token) {
            if (req.headers.has('req_type') && req.headers.get('req_type') === 'file') {
                req = req.clone({ 'responseType': 'blob' });
            }
            else {
                newHeaders = newHeaders.append('Content-Type', 'application/json');
            }
            newHeaders = newHeaders.append('Authorization', token);
        }
        const authReq = req.clone({ headers: newHeaders });
        return next.handle(authReq).pipe(map(resp => {
            if (resp instanceof HttpResponse) {
                setTimeout(() => {
                    this.jqueryRunner.windowLoadInit(true);
                }, 2000);
                return resp;
            }
        }));
    }
}
HttpInterceptorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HttpInterceptorService_Factory() { return new HttpInterceptorService(i0.ɵɵinject(i1.JqueryRunnerService)); }, token: HttpInterceptorService, providedIn: "root" });
